<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/64/image-replace.svg" size="2"></app-svg>

  <h1>Replace Images</h1>
  <p>{{duplicates.length}} image<span *ngIf="duplicates.length !== 1">s</span> already exist with the same filename. Do
    you want to replace existing images with a new image version?</p>

  <button appButton name="confirm" location="duplicate-images-dialog"  color="primary" (click)="override()" height="4" size="3"
    weight="bold" spacing="full" data-test-id="duplicate-replace">Replace</button>
  <button appButton name="skip" location="duplicate-images-dialog"  color="hard-simple" (click)="skip()" size="3" weight="bold"
    spacing="full">Skip Duplicates</button>
</div>
